import { useRef, useState } from "react";
import { useDisplayName } from "../room/useDisplayName";

export function Footer() {
  const { edited, placeholder, setDisplayName } = useDisplayName();
  const [focused, setFocused] = useState(false);
  const [draft, setDraft] = useState("");
  const ref = useRef<HTMLInputElement>(null);

  // While focused, show the draft value; otherwise show the committed `edited` value.
  const value = focused ? draft : edited;

  const handleFocus = () => {
    setDraft(edited);
    setFocused(true);
  };

  const handleBlur = () => {
    setFocused(false);
    setDisplayName(draft);
  };

  return (
    <footer className="flex flex-col items-center gap-1 px-4 py-3 text-center text-xs text-[var(--muted)]">
      <input
        ref={ref}
        value={value}
        placeholder={placeholder}
        aria-label="Your display name"
        maxLength={32}
        onFocus={handleFocus}
        onChange={(e) => setDraft(e.target.value)}
        onBlur={handleBlur}
        onKeyDown={(e) => { if (e.key === "Enter" || e.key === "Escape") { e.preventDefault(); ref.current?.blur(); } }}
        className="w-48 rounded-md border border-transparent bg-transparent px-2 py-1 text-center text-sm text-[var(--text)] hover:border-[var(--border)] focus:border-[var(--border)] focus:outline-none"
      />
      <span>Peer-to-peer · No signup</span>
    </footer>
  );
}
